// Legacy rows used active for both concepts. Explicit visibility wins once the
// schema has been upgraded; availability remains controlled by active.
export const isProductVisibleInMenu = (product) =>
  (product?.visibleInMenu ?? product?.visible_in_menu ?? product?.active) !== false;
